import React from 'react';
import { styled } from '@withjoy/joykit';

interface IframeProps extends React.IframeHTMLAttributes<HTMLIFrameElement> {
  scale?: number;
}

const Iframe = styled.iframe<IframeProps>`
  width: ${({ scale = 1 }) => `calc(1 / ${scale} * 100%)`};
  height: ${({ scale = 1 }) => `calc(1 / ${scale} * 100%)`};
  border: none;
  pointer-events: auto;
  transform: ${({ scale = 1 }) => `scale(${scale})`};
  transform-origin: top left;
`;

interface WebsitePreviewProps {
  eventHandle: string;
}
const WebsitePreview: React.FC<WebsitePreviewProps> = ({ eventHandle }) => {
  const src = `/${eventHandle}?ctx=adminGuestSitePreview&amp;feature.enableloadingstyleapplicator=false&amp;feature.nossr=true&amp;preview=true&amp;target=charm`;
  return (
    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
      <Iframe
        sandbox="allow-scripts allow-same-origin"
        src={src}
        scale={1}
      ></Iframe>
    </div>
  );
};

export default WebsitePreview;
